import pick from "lodash/pick";
import { IHAQWithContent } from "hooks/api/GQL/haq/useHAQsWithContent.models";
import { IIndividualInvitation } from "models/assets.models";
import { IDocument } from "models/documents.models";
import { IHAQ } from "models/HAQ.models";
import { AssetType } from "utils/constants/assets.constants";

export const getAssetUpdatePayload = (
  data: IHAQ | IHAQWithContent | IDocument | IIndividualInvitation,
) => {
  return data.type === AssetType.IndividualInvitation
    ? {
        ...data,
        // Activation reminder dates are derived for responses and must not be saved as asset metadata.
        metadata: pick(data.metadata, [
          "email",
          "tenantId",
          "fileType",
          "originator",
          "invitationSent",
          "authoringTenantId",
          "failedResend",
        ]),
      }
    : data;
};
